<div class="content-wrapper">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>

    <section id="sample-page">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body pb-1">
              <form #cadastroForm="ngForm">
                <div class="card-body pb-1">
                  <!-- Nome -->
                  <div class="col-md-6 col-12">
                    <div class="form-group mb-2">
                      <label>Nome</label>
                      <input [(ngModel)]="nome" #nomeRef="ngModel" required
                        type="text" name="nome" class="form-control"
                        [class.error]="!nomeRef.valid && cadastroForm.submitted"
                        placeholder="Nome do Despachante" />
                      <span *ngIf="cadastroForm.submitted && nomeRef.invalid" class="invalid-form">
                        <small class="form-text text-danger" *ngIf="nomeRef.errors?.required">
                          Campo Obrigatório!
                        </small>
                      </span>
                    </div>
                  </div>

                  <!-- CNPJ -->
                  <!-- <div class="col-md-6 col-12">
                    <div class="form-group mb-2">
                      <label>CNPJ</label>
                      <input [(ngModel)]="cnpj" name="cnpj" class="form-control"
                        type="text" placeholder="CNPJ" />
                    </div>
                  </div> -->

                  <!-- Telefone -->
                  <div class="col-md-6 col-12">
                    <div class="form-group mb-2">
                      <label>Telefone</label>
                      <input [(ngModel)]="telefone" name="telefone" class="form-control"
                        type="text" placeholder="Telefone" />
                    </div>
                  </div>

                  <!-- Email -->
                  <div class="col-md-6 col-12">
                    <div class="form-group mb-2">
                      <label>Email</label>
                      <input [(ngModel)]="email" name="email" class="form-control"
                        type="email" placeholder="Email" />
                    </div>
                  </div>

                  <!-- Endereço -->
                  <div class="col-md-6 col-12">
                    <div class="form-group mb-2">
                      <label>Endereço</label>
                      <input [(ngModel)]="endereco" name="endereco" class="form-control"
                        type="text" placeholder="Endereço" />
                    </div>
                  </div>

                  <!-- Status -->
                  <div class="col-md-6 col-12">
                    <div class="form-group mb-2">
                      <label>Status</label>
                      <select [(ngModel)]="flg_status" name="flg_status" class="form-control" required>
                        <option [value]="1">Ativo</option>
                        <option [value]="2">Inativo</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-12 mt-50">
                    <button routerLink="/despachante" class="btn btn-secondary botao-cancelar"
                      rippleEffect>Cancelar</button>

                    <button (click)="submitForm(cadastroForm)" type="submit"
                      class="btn btn-primary btn-next" rippleEffect>
                      <span class="align-middle d-sm-inline-block d-none">Salvar</span>
                      <i data-feather="arrow-right" class="align-middle ml-sm-25 ml-0"></i>
                    </button>
                    <br>
                    <br>
                    <div *ngIf="isLoading" class="spinner-border"></div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
